import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: 16px;
    container-type: inline-size;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 26px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.font};
`;

export const Description = styled.p`
    margin: 0;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const CardsGrid = styled.div`
    display: grid;
    gap: 16px;
`;

export const EmptyState = styled.div`
    background: ${({ theme }) => theme.colors.componentBackground};
    border: 1px dashed ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 12px;
    padding: 50px 20px;
    text-align: center;
`;

export const EmptyStateTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.antdText};
    margin-bottom: 4px;
`;

export const EmptyStateDescription = styled.div`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.lightFont};
`;

export const LoadingMore = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 20px 0;
    color: ${({ theme }) => theme.colors.lightFont};
    font-size: 13px;
`;

export const PrevButtonArea = styled.div`
    width: 100%;
`;
